import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
} from "@devhop/ui";
import { useEffect, useState } from "react";

type NoteDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentNote?: string;
  onSave: (note: string) => void;
};

export function NoteDialog({
  open,
  onOpenChange,
  currentNote,
  onSave,
}: NoteDialogProps) {
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) {
      setNote(currentNote || "");
    }
  }, [open, currentNote]);

  const handleSave = () => {
    onSave(note);
    onOpenChange(false);
  };

  const handleCancel = () => {
    setNote(currentNote || "");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ເພີ່ມໝາຍເຫດ</DialogTitle>
          <DialogDescription>ເພີ່ມໝາຍເຫດສຳລັບລາຍການນີ້</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="note">ໝາຍເຫດ</Label>
            <textarea
              id="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="ຕົວຢ່າງ: ບໍ່ຕ້ອງນຳ້ຕານ, ຮ້ອນຫຼາຍ..."
              rows={3}
              className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            ຍົກເລີກ
          </Button>
          <Button onClick={handleSave}>ບັນທຶກ</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
